import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { partnerApi } from "@/lib/partnerApi";

const PartnerAuthContext = createContext(null);

export function PartnerAuthProvider({ children }) {
    const [partner, setPartner] = useState(null); // null = a verificar, false = sem sessão

    const refresh = useCallback(async () => {
        try {
            const { data } = await partnerApi.get("/auth/me");
            setPartner(data);
        } catch {
            setPartner(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const logout = useCallback(async () => {
        try { await partnerApi.post("/auth/logout"); } catch { /* limpa a sessão local na mesma */ }
        setPartner(false);
    }, []);

    const value = useMemo(() => ({ partner, setPartner, refresh, logout }), [partner, refresh, logout]);
    return <PartnerAuthContext.Provider value={value}>{children}</PartnerAuthContext.Provider>;
}

export const usePartner = () => useContext(PartnerAuthContext);
